import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var filterOptionSchema = {
    value: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Стойност на български *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидна стойност',
    }),
    en_value: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Стойност на английски*',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидна стойност',
    }),
    filter_type: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control category-dropdown',
            placeholder: '',
            options: []
        }),
        elementType: 'dropdown',
        label: 'Тип филтър*',
        validation: {
            required: true
        },
        value: '',
        valid: false,
        touched: false,
        hidden: true
    }),
};
export default filterOptionSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/filterOptionSchema.ts
// module id = 353
// module chunks = 0